import React from 'react';

const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      quote: "Our financially stable, fully compliant company faced an inexplicable block on our credit insurance, hindering growth. For years, direct talks with underwriters yielded no results. The TREVEX team meticulously dissected our operations and financials, corrected erroneous information, and successfully negotiated the removal of the block while securing new credit limits. We're grateful and fully recommend TREVEX as a crucial business partner.",
      name: "IT Distributions Business",
      role: "Chief Financial Officer",
      bgColor: "bg-gradient-to-br from-[#fb512d] to-[#411005]",
      textColor: "text-white",
      shadow: "shadow-lg"
    },
    {
      id: 2,
      quote: "At Credible X, our mission has always been to empower SMEs through accessible and innovative financial solutions. Our partnership with TREVEX has been a significant milestone in that journey. TREVEX brings a forward-thinking, collaborative approach to the fintech ecosystem, and working alongside their team has been seamless and strategically aligned. We’re proud to collaborate with TREVEX in driving SME growth and advancing the future of embedded finance",
      name: "Credible X",
      role: "CEO & Founder",
      bgColor: "bg-white",
      textColor: "text-[#1d1415]",
      roleColor: "text-[#7c7777]",
      shadow: "shadow-sm"
    },
    {
      id: 3,
      quote: "TREVEX played a crucial role in helping us develop a robust credit policy and successfully navigate the complex trading landscape in the United Arab Emirates. We strongly endorse their services for businesses aiming to strengthen their payment terms and cultivate reliable relationships with both buyers and suppliers.",
      name: "Commodity Training Business",
      role: "Business Manager",
      bgColor: "bg-[#002940]",
      textColor: "text-white",
      shadow: "shadow-sm"
    }
  ];

  return (
    <div className="w-full sm:w-[400px] lg:w-full mx-auto px-4 py-12">
      <div className="flex flex-col lg:flex-row gap-3 justify-center items-stretch">
        {testimonials.map((testimonial) => (
          <div 
            key={testimonial.id}
            className={`${testimonial.bgColor} ${testimonial.shadow} rounded-2xl border border-[#e8e8e8] p-6 flex flex-col justify-between flex-1 min-w-0 max-w-full lg:w-[408px] text-left`}
          >
            <div className="mb-6">
              <p className={`${testimonial.textColor} font-normal text-[1.125rem] leading-[150%] font-sans`}>
                {testimonial.quote}
              </p>
            </div>
            <div className="flex flex-col gap-0.5">
              <p className={`${testimonial.textColor} font-semibold text-[1rem] leading-[150%] font-sans`}>
                {testimonial.name}
              </p>
              <p className={`${testimonial.roleColor || testimonial.textColor} font-normal text-[0.8125rem] leading-[150%] font-sans`}>
                {testimonial.role}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Testimonials;